import { v4 as uuid } from 'uuid';
import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { ILodgementLodgeHistory } from './LodgementLodgeHistory.interface';

export default class LodgementLodgeHistory implements ILodgementLodgeHistory {
  id: string;
  idWorkflow: string;
  idStage: string;
  idAccount: string;
  idLender: string;
  applicationId: string;
  event: string;
  timeStamp: number;

  static build = (data: ILodgementLodgeHistory) => new LodgementLodgeHistory(data);
  static blank = () => new LodgementLodgeHistory();

  /**
   * Constructor
   * @param {ILodgementLodgeHistory} data
   */
  constructor(data?: ILodgementLodgeHistory) {
    this.id = toUUID(data?.id) || uuid();
    this.idWorkflow = toUUID(data?.idWorkflow);
    this.idStage = toUUID(data?.idStage);
    this.idAccount = toUUID(data?.idAccount);
    this.idLender = data?.idLender || undefined;
    this.applicationId = data?.applicationId || undefined;
    this.event = data?.event || undefined;
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
